'use es6';

import { useContext } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { ToggleGroup } from 'foundations-components/transitional/components/ToggleGroup';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { AssetPermission } from '../../../permissions/assetPermission';
import { PermissionSettingsContext } from './context/PermissionSettingsContext';
import { ASSIGNMENT_MODES, PERMISSION_SETTINGS_USES, ASSET_TYPES, AssetTypePropType } from './constants';
import { useCanAssignSpecificPermissionGrants } from '../../../access/scopes/hooks/useHasScope';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const {
  EDIT,
  VIEW,
  ZERO
} = AssetPermission;
const {
  EVERYONE,
  SPECIFIC,
  PRIVATE
} = ASSIGNMENT_MODES;
const AccessLevelRadioGroup = ({
  value,
  onChange
}) => {
  const groupName = 'access-level';
  return /*#__PURE__*/_jsxs(ToggleGroup, {
    name: groupName,
    paddingInlineStart: "600",
    children: [/*#__PURE__*/_jsx(RadioInput, {
      "data-test-id": "access-level-edit",
      checked: value === EDIT,
      name: groupName,
      onChange: () => {
        onChange(EDIT);
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.permissions.accessLevel.edit"
      })
    }), /*#__PURE__*/_jsx(RadioInput, {
      "data-test-id": "access-level-view",
      checked: value === VIEW,
      name: groupName,
      onChange: () => {
        onChange(VIEW);
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.permissions.accessLevel.view"
      })
    })]
  });
};
const AssignmentModeControl = ({
  assetCount = 1,
  assetType
}) => {
  const state = useContext(PermissionSettingsContext);
  const {
    use,
    accessLevel,
    assignmentMode,
    setAccessLevel,
    setAssignmentMode
  } = state;
  const showSpecificAssignmentOption = useCanAssignSpecificPermissionGrants();
  const accessLevelRadioGroup = /*#__PURE__*/_jsx(AccessLevelRadioGroup, {
    value: accessLevel,
    onChange: setAccessLevel
  });
  const inputName = 'assignment-mode';
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: assetType === ASSET_TYPES.DASHBOARD ? 'reporting-action-components.permissions.assignmentMode.label.dashboard' : 'reporting-action-components.permissions.assignmentMode.label.report',
      options: {
        count: assetCount
      }
    }),
    children: /*#__PURE__*/_jsxs(ToggleGroup, {
      name: inputName,
      children: [/*#__PURE__*/_jsx(RadioInput, {
        "data-test-id": "assignment-mode-private",
        checked: assignmentMode === PRIVATE,
        name: inputName,
        onChange: () => {
          setAssignmentMode(PRIVATE);
          setAccessLevel(ZERO);
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: use === PERMISSION_SETTINGS_USES.CREATE ? 'reporting-action-components.permissions.assignmentMode.privateForNewAsset' : 'reporting-action-components.permissions.assignmentMode.private'
        })
      }), /*#__PURE__*/_jsx(RadioInput, {
        "data-test-id": "assignment-mode-everyone",
        checked: assignmentMode === EVERYONE,
        name: inputName,
        onChange: () => {
          setAssignmentMode(EVERYONE);
          setAccessLevel(EDIT);
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.permissions.assignmentMode.everyone"
        })
      }), assignmentMode === EVERYONE && accessLevelRadioGroup, showSpecificAssignmentOption && /*#__PURE__*/_jsx(RadioInput, {
        "data-test-id": "assignment-mode-specific",
        checked: assignmentMode === SPECIFIC,
        name: inputName,
        onChange: () => {
          setAssignmentMode(SPECIFIC);
          setAccessLevel(EDIT);
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.permissions.assignmentMode.specific"
        })
      }), showSpecificAssignmentOption && assignmentMode === SPECIFIC && accessLevelRadioGroup]
    })
  });
};
AssignmentModeControl.propTypes = {
  assetCount: PropTypes.number,
  assetType: AssetTypePropType.isRequired
};
export default AssignmentModeControl;